/**
 * Short address (national address) codes are exactly 8 chars, e.g. RRRR1234.
 * Users often paste them with leading/trailing (or inner) spaces, which breaks
 * both the address lookup and the `length(8)` validation on submit.
 */
const sanitizeShortAddress = (value) =>
    typeof value === "string" ? value.replace(/\s/g, "").toUpperCase() : value;

export default sanitizeShortAddress;
